import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    categories: [],
    medicines: [],
    blogs: [],
    inquiries: [],
    distributors: [],
    states: [],
    cities: [],
    brands: [],
    allCategories: [],
    allBrands: [],
    allBrandsData: [],
  },
  computed: {
    categories() {
      console.log("fgvds", this.$store.state.categories);
      return this.$store.state.categories;
    },

    medicines() {
      return this.$store.state.medicines;
    },

    blogs() {
      return this.$store.state.blogs;
    },
    inquiries() {
      console.log("inquiries", this.$store.state.inquiries);
      return this.$store.state.inquiries;
    },
    distributors() {
      console.log("distributors", this.$store.state.distributors);
      return this.$store.state.distributors;
    },
    brands() {
      console.log("brands", this.$store.state.brands);
      return this.$store.state.brands;
    }
  },
  mutations: {
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_MEDICINES(state, medicines) {
      state.medicines = medicines;
    },
    SET_BLOGS(state, blogs) {
      state.blogs = blogs;
    },
    SET_INQUIRIES(state, inquiries) {
      state.inquiries = inquiries;
    },
    EDIT_CATEGORY(state, updatedCategory) {
      const index = state.categories.data.findIndex(
        (category) => category.id === updatedCategory.id
      );
      if (index !== -1) {
        state.categories.data.splice(index, 1, updatedCategory);
      }
    },
    EDIT_MEDICINES(state, updatedMedicine) {
      const index = state.medicines.data.findIndex(
        (medicine) => medicine.id === updatedMedicine.id
      );
      if (index !== -1) {
        state.medicines.data.splice(index, 1, updatedMedicine);
      }
    },
    EDIT_INQUIRIES(state, updatedInquiry) {
      const index = state.inquiries.data.findIndex(
        (inquiry) => inquiry.id === updatedInquiry.id
      );
      if (index !== -1) {
        state.inquiries.data.splice(index, 1, updatedInquiry);
      }
    },

    DELETE_MEDICINE(state, medicineId) {
      if (state.medicines.data) {
        state.medicines.data = state.medicines.data.filter(
          (medicine) => medicine.id !== medicineId
        );
      }
    },

    DELETE_CATEGORY(state, categoryId) {
      if (state.categories.data) {
        state.categories.data = state.categories.data.filter(
          (category) => category.id !== categoryId
        );
      }
    },
    DELETE_INQUIRY(state, inquiryId) {
      if (state.categories.data) {
        state.inquiries.data = state.inquiries.data.filter(
          (inquiry) => inquiry.id !== inquiryId
        );
      }
    },
    SET_DISTRIBUTORS(state, distributors) {
      state.distributors = distributors;
    },
    EDIT_DISTRIBUTOR(state, updatedDistributor) {
      const index = state.distributors.findIndex(
        (distributor) => distributor.id === updatedDistributor.id
      );
      if (index !== -1) {
        state.distributors.splice(index, 1, updatedDistributor);
      }
    },
    DELETE_DISTRIBUTOR(state, distributorId) {
      if (Array.isArray(state.distributors)) {
          state.distributors = state.distributors.filter(
              (distributor) => distributor.id !== distributorId
          );
      } else {
          console.error('Attempted to filter non-array distributors state');
      }
    },
    SET_STATES(state, states) {
      state.states = states;
    },
    SET_CITIES(state, cities) {
      state.cities = cities;
    },
    SET_BRANDS(state, brands) {
      state.brands = brands;
    },
    EDIT_BRANDS(state, updatedBrand) {
      const index = state.brands.findIndex(
        (brand) => brand.id === updatedBrand.id
      );
      if (index !== -1) {
        state.brands.splice(index, 1, updatedBrand);
      }
    },
    DELETE_BRANDS(state, brandId) {
      if (Array.isArray(state.brands)) {
          state.brands = state.brands.filter(
              (brand) => brand.id !== brandId
          );
      } else {
          console.error('Attempted to filter non-array brands state');
      }
    },
    SET_ALL_CATEGORIES(state, categories) {
      state.allCategories = categories;
    },
    SET_ALL_BRANDS(state, brands) {
      state.allBrands = brands;
    },
    SET_ALL_BRANDS_DATA(state, brands) {
      state.allBrandsData = brands;
    }
  },
  actions: {
    async fetchItems({ commit }, { page, perPage, search = "" }) {
      const currentPage = page || 1;
      const itemsPerPage = perPage || 10;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/categories?page=${currentPage}&perPage=${itemsPerPage}&search=${search}`
        );
        commit("SET_CATEGORIES", response.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    async fetchMedicines(
      { commit },
      {
        page,
        perPage,
        search = "",
        brands = [],
        is_active = false,
        in_stock = false,
      }
    ) {
      let brandQuery = [];
      if (Array.isArray(brands) && brands.length) {
        brandQuery = brands.join(",");
      }
      const currentPage = page || 1;
      const itemsPerPage = perPage || 10;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/medicines?page=${currentPage}&perPage=${itemsPerPage}&search=${search}&brands=${brandQuery}&is_active=${is_active}&in_stock=${in_stock}`
        );
        console.log("hellllo lollll",response.data.medicines);
        commit("SET_MEDICINES", response.data.medicines);
      } catch (error) {
        console.error("Error fetching medicines:", error);
      }
    },

    async addItem({ dispatch }, { formData, page, perPage }) {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/api/categories`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        dispatch("fetchItems", { page, perPage, search: "" });
      } catch (error) {
        console.error("Error adding category:", error);
      }
    },

    async addMedicine({ dispatch }, { formData, page, perPage }) {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/api/medicines`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        dispatch("fetchMedicines", { page, perPage, search: "" });
        console.log("Medicine added successfully");
      } catch (error) {
        console.error("Error adding medicine:", error);
      }
    },

    async editItem({ commit }, updatedCategory) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/categories/${updatedCategory.id}/update`,
          updatedCategory,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Edit response:", response);
        commit("EDIT_CATEGORY", response.data.category);
      } catch (error) {
        console.error("Error updating category:", error);
      }
    },

    async updateMedicine({ commit }, updatedMedicine) {
      try {
        console.log("formDataaaaa", updatedMedicine);
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/medicines/${updatedMedicine.id}/update`,
          updatedMedicine,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Update responsewwwwww:", response);
        commit("EDIT_MEDICINES", updatedMedicine);
      } catch (error) {
        console.error("Error updating medicine:", error);
      }
    },

    async deleteItem({ commit }, categoryId) {
      try {
        const response = await axios.delete(
          `${process.env.VUE_APP_URL}/api/categories/${categoryId}/delete`
        );
        console.log("Delete response:", response);
        commit("DELETE_CATEGORY", categoryId);
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    },

    async deleteMedicine({ commit }, medicineId) {
      try {
        await axios.delete(
          `${process.env.VUE_APP_URL}/api/medicines/${medicineId}/delete`
        );
        commit("DELETE_MEDICINE", medicineId);
      } catch (error) {
        console.error("Error deleting medicine:", error);
      }
    },
    
    // Blog Action  

    async fetchBlogs({ commit }, { page, perPage, search = "" }) {
      const currentPage = page || 1;
      const itemsPerPage = perPage || 10;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/blogs?page=${currentPage}&perPage=${itemsPerPage}&search=${search}`
        );
        commit("SET_BLOGS", response.data.blogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    },

    async addBlog({ dispatch }, { formData, page, perPage }) {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/api/blogs`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
          
        dispatch("fetchBlogs", { page, perPage, search: "" });
      } catch (error) {
        console.error("Error adding blog:", error);
      }
    },

    async updateBlog({ commit }, updatedBlog) {
      try {
        console.log("updatedBlog", updatedBlog);
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/blogs/${updatedBlog.id}/update`, updatedBlog,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Update blog:", response);
        // commit("EDIT_BLOGS", updatedBlog);
      } catch (error) {
        console.error("Error updating medicine:", error);
      }
    },

    async deleteBlog({ commit }, BlogId) {
      try {
        await axios.delete(
          `${process.env.VUE_APP_URL}/api/blogs/${BlogId}/delete`
        );
        // commit("DELETE_BLOG", BlogId);
      } catch (error) {
        console.error("Error deleting blog:", error);
      }
    },

    // Inquiry Action'

    async fetchInquiries({ commit }, { page, perPage, search = "" }) {
      const currentPage = page || 1;
      const itemsPerPage = perPage || 10;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/inquiries?page=${currentPage}&perPage=${itemsPerPage}&search=${search}`
        );
        console.log("hello",response.data.inquiries);
        commit("SET_INQUIRIES", response.data.inquiries);
      } catch (error) {
        console.error("Error fetching inquiries:", error);
      }
    },

    async addInquiry({ dispatch }, { formData, page, perPage }) {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/api/inquiries`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
          
        dispatch("fetchInquiries", { page, perPage, search: "" });
      } catch (error) {
        console.error("Error adding blog:", error);
      }
    },

    async updateInquiry({ commit }, updatedInquiry) {
      try {
        console.log("updatedInquiry", updatedInquiry);
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/inquiries/${updatedInquiry.id}/update`, updatedInquiry,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Update inquiry:", response);
        // commit("EDIT_INQUIRIES", updatedInquiry);
      } catch (error) {
        console.error("Error updating inquiry:", error);
      }
    },

    async deleteInquiry({ commit }, InquiryId) {
      try {
        await axios.delete(
          `${process.env.VUE_APP_URL}/api/inquiries/${InquiryId}/delete`
        );
        // commit("DELETE_INQUIRY", InquiryId);
      } catch (error) {
        console.error("Error deleting inquiry:", error);
      }
    },

    // Distributor Action

    async fetchDistributors({ commit }, { page, perPage, search = "" }) {
      const currentPage = page || 1;
      const itemsPerPage = perPage || 10;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/distributors?page=${currentPage}&perPage=${itemsPerPage}&search=${search}`
        );
        console.log("hello",response.data.distributors);
        commit("SET_DISTRIBUTORS", response.data.distributors);
      } catch (error) {
        console.error("Error fetching distributors:", error);
      }
    },
    async addDistributor({ dispatch }, { formData, page, perPage }) {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/api/distributors`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        dispatch("fetchDistributors", { page, perPage, search: "" });
      } catch (error) {
        console.error("Error adding distributor:", error);
      }
    },
    async updateDistributor({ commit }, { updatedDistributor}){
      console.log("11 updatedDistributor", updatedDistributor);
      try {
        console.log("updatedDistributor", updatedDistributor);
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/distributors/${updatedDistributor.id}/update`, updatedDistributor,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Update distributor:", response);
        // commit("EDIT_DISTRIBUTORS", updatedDistributor);
      } catch (error) {
        console.error("Error updating distributor:", error);
      }
    },
    async deleteDistributor({ commit }, distributorId) {

      try {
        await axios.delete(
          `${process.env.VUE_APP_URL}/api/distributors/${distributorId}/delete`
        );
        // commit("DELETE_DISTRIBUTOR", distributorId);
      } catch (error) {
        console.error("Error deleting distributor:", error);
      }
    },
    async fetchStates({ commit }) {
        try {
            const response = await axios.get(`${process.env.VUE_APP_URL}/api/states`);
            commit('SET_STATES', response.data.states);
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    },
    async fetchCities({ commit }, stateId) {
        try {
            const response = await axios.post(`${process.env.VUE_APP_URL}/api/cities`, { state_id: stateId.state_id });
            commit('SET_CITIES', response.data.cities);
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    },

     // Brand Action

     async fetchBrands({ commit }, { page, perPage, search = "" }) {
      const currentPage = page || 1;
      const itemsPerPage = perPage || 10;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/brands?page=${currentPage}&perPage=${itemsPerPage}&search=${search}`
        );
        console.log("hello",response.data.brands);
        commit("SET_BRANDS", response.data.brands);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    },
    async addBrand({ dispatch }, { formData, page, perPage }) {
      try {
        await axios.post(`${process.env.VUE_APP_URL}/api/brands`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        dispatch("fetchBrands", { page, perPage, search: "" });
      } catch (error) {
        console.error("Error adding brand:", error);
      }
    },
    async updateBrand({ commit }, { updatedBrand}){
      console.log("11 updatedBrand", updatedBrand);
      try {
        console.log("updatedBrand", updatedBrand);
        const response = await axios.post(
          `${process.env.VUE_APP_URL}/api/brands/${updatedBrand.id}/update`, updatedBrand,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("Update brand:", response);
        // commit("EDIT_DISTRIBUTORS", updatedDistributor);
      } catch (error) {
        console.error("Error updating brand:", error);
      }
    },
    async deleteBrand({ commit }, brandId) {
      try {
        await axios.delete(
          `${process.env.VUE_APP_URL}/api/brands/${brandId}/delete`
        );
        // commit("DELETE_DISTRIBUTOR", distributorId);
      } catch (error) {
        console.error("Error deleting distributor:", error);
      }
    },
    async fetchAllCategories({ commit }) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_URL}/api/categoriesData`
        );
        console.log("hello 565",response);
        commit("SET_ALL_CATEGORIES", response.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    }, 
    async fetchAllBrandsData({ commit }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_URL}/api/brands-data`);
        console.log("hello 60200",response);
        commit("SET_ALL_BRANDS_DATA", response.data.brands);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    },
  }
});